import React from "react";
import { Modal } from "react-bootstrap";

export default function NeedHelpModal(props) {
  const { show, closeModal, title, pmgInvestIndiaMail, pmgSupportMail } = props;

  return (
    <React.Fragment>
      <Modal
        show={show}
        dialogClassName="banner-modal need-help-modal"
        onHide={closeModal}
        data-test="contact-us-details-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{title || `Contact Us`}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>
            <b>Please send us an e-mail on the following ID: </b>
            <ul>
              <li>{pmgInvestIndiaMail}</li>
            </ul>
          </p>
          <div>
            <u>
              <strong>
                <u>Or Contact:</u>
              </strong>
            </u>
            <div>Rohit Dua</div>
            <div>Technology Lead, Project Monitoring Group (PMG)</div>
            <div>Secretariat to Monitoring Group, PMO</div>
            <div>Government of India</div>
            <br />

            <div>
              <strong>Address:</strong> GPOA 3, Netaji Nagar, New Delhi-110023
            </div>
            <div>
              <strong>Mobile:</strong> +91 9923478514
            </div>
            <div>
              <strong>Landline:</strong> (011) 26773798
            </div>
            <div>
              <strong>Monday – Friday (10:00 AM – 6:00 PM)</strong>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
